import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// on dom ready
document.addEventListener("DOMContentLoaded", () => {
  const stats = document.querySelector("#stats") as HTMLElement;
  if (!stats) return;

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(".stats-item", {
    opacity: 0,
    y: 100,
  });

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: stats,
      start: "top 80%",
      // markers: true,
    },
  });

  tl.to(".stats-item", {
    duration: 0.8,
    opacity: 1,
    y: 0,
    stagger: 0.2,
    ease: "power2.out",
  });
});
